import { StepSegments } from "./joinSteps"

const StorageKey = "artemis.refer_code"

// localStorage throws in Safari private browsing, so every access is guarded
export function storedReferCode(): string {
  try {
    return localStorage.getItem(StorageKey) || ""
  } catch {
    return ""
  }
}

export function clearReferCode() {
  try {
    localStorage.removeItem(StorageKey)
  } catch {
    // nothing to clean up
  }

  // The code rides in the address bar now, so forgetting it has to scrub there
  // too -- otherwise a reload would capture the same rejected code straight
  // back out of the URL and wedge this browser on the error screen.
  const url = new URL(window.location.href)
  if (url.searchParams.has("ref")) {
    url.searchParams.delete("ref")
    window.history.replaceState(null, "", `${url.pathname}${url.search}`)
  }
}

function storeReferCode(code: string) {
  try {
    localStorage.setItem(StorageKey, code)
  } catch {
    // the address bar still carries the code, so this page load works
  }
}

// The address bar is the source of truth once captureReferCode has run; the
// stored copy only matters when storage worked and the URL was later scrubbed.
export function currentReferCode(): string {
  const query = new URLSearchParams(window.location.search).get("ref")
  return (query || storedReferCode()).trim()
}

// Invites arrive as /?ref=CODE, or as the /CODE path the iOS app shares. The
// code is kept in the address bar from here on so the member can forward the
// link at any point in the flow, and localStorage only backs it up for a link
// that arrived without it.
//
// The address bar is normalised to step one before React mounts. The wizard
// lives in memory, so a forwarded link to a later step has nothing to resume --
// the friend who opens it has to start from the beginning.
export function captureReferCode() {
  const query = new URLSearchParams(window.location.search).get("ref")
  const segment = decodeURIComponent(window.location.pathname.split("/")[1] || "")

  const code = (query || (StepSegments.includes(segment) ? "" : segment) || storedReferCode()).trim()

  if (!code) {
    return
  }

  storeReferCode(code)
  window.history.replaceState(null, "", `/?ref=${encodeURIComponent(code)}`)
}
